namespace GeniuzPOS.InitialData {
    export interface PsOtherPaymentRow {
        Id?: number;
        OtherPaymentType?: string;
        OtherPaymentName?: string;
        ProdImageLink?: string;
        IsActive?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsOtherPaymentRow {
        export const idProperty = 'OtherPaymentType';
        export const nameProperty = 'OtherPaymentName';
        export const localTextPrefix = 'InitialData.PsOtherPayment';
        export const lookupKey = 'InitialData.PsOtherPayment';

        export function getLookup(): Q.Lookup<PsOtherPaymentRow> {
            return Q.getLookup<PsOtherPaymentRow>('InitialData.PsOtherPayment');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทการชำระเงินอื่นๆ:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทการชำระเงินอื่นๆ:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทการชำระเงินอื่นๆ:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทการชำระเงินอื่นๆ:Modify';

        export declare const enum Fields {
            Id = "Id",
            OtherPaymentType = "OtherPaymentType",
            OtherPaymentName = "OtherPaymentName",
            ProdImageLink = "ProdImageLink",
            IsActive = "IsActive",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
